export default {"src":"/_next/static/media/account_balance.2a37f556.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};